import React from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/services.css'

export default class Services extends React.Component {
  render() {
    return (
      <div className="services-container">
        <div className='container-fluid'>
          <div className="row">
            <div className="col-6 col-sm-6 col-xl-3 service">
              <div className='service-text'>
                <h5 className="bold deep-blue-text">Investment Banking</h5>
                <p>The FSDH Investment Banking Division was set up for the purpose of creating capital for our clients, whilst ensuring that they achieve their strategic goals. </p>
                <Link to="/" className="gray-bordered-button-sm">Learn more</Link>
              </div>
            </div>
            <div className="col-6 col-sm-6 col-xl-3 service">
              <div className='service-text'>
                <h5 className="bold deep-blue-text">Wealth Management</h5>
                <p>The FSDH Investment Banking Division was set up for the purpose of creating capital for our clients, whilst ensuring that they achieve their strategic goals. </p>
                <Link to="/services/wealthmanagement" className="gray-bordered-button-sm">Learn more</Link>
              </div>
            </div>
            <div className="col-6 col-sm-6 col-xl-3 service">
              <div className='service-text'>
                <h5 className="bold deep-blue-text">Corporate Banking</h5>
                <p>The FSDH Investment Banking Division was set up for the purpose of creating capital for our clients, whilst ensuring that they achieve their strategic goals. </p>
                <Link to="/" className="gray-bordered-button-sm">Learn more</Link>
              </div>
            </div>
            <div className="col-6 col-sm-6 col-xl-3 service">
              <div className='service-text'>
                <h5 className="bold deep-blue-text">Treasury Sales</h5>
                <p>The FSDH Investment Banking Division was set up for the purpose of creating capital for our clients, whilst ensuring that they achieve their strategic goals. </p>
                <Link to="/" className="gray-bordered-button-sm">Learn more</Link>
              </div>
            </div>
            <div className="col-6 col-sm-6 col-xl-3 service">
              <div className='service-text'>
                <h5 className="bold deep-blue-text">Stockbroking</h5>
                <p>The FSDH Investment Banking Division was set up for the purpose of creating capital for our clients, whilst ensuring that they achieve their strategic goals. </p>
                <Link to="/" className="gray-bordered-button-sm">Learn more</Link>
              </div>
            </div>
            <div className="col-6 col-sm-6 col-xl-3 service">
              <div className='service-text'>
                <h5 className="bold deep-blue-text">Pension funds</h5>
                <p>The FSDH Investment Banking Division was set up for the purpose of creating capital for our clients, whilst ensuring that they achieve their strategic goals. </p>
                <Link to="/" className="gray-bordered-button-sm">Learn more</Link>
              </div>
            </div>
            <div className="col-6 col-sm-6 col-xl-3 service">
              <div className='service-text'>
                <h5 className="bold deep-blue-text">Fixed Income Trading</h5>
                <p>The FSDH Investment Banking Division was set up for the purpose of creating capital for our clients, whilst ensuring that they achieve their strategic goals. </p>
                <Link to="/" className="gray-bordered-button-sm">Learn more</Link>
              </div>
            </div>
            <div className="col-6 col-sm-6 col-xl-3 service">
              <div className='service-text'>
                <h5 className="bold deep-blue-text">Interest Rate Trading</h5>
                <p>The FSDH Investment Banking Division was set up for the purpose of creating capital for our clients, whilst ensuring that they achieve their strategic goals. </p>
                <Link to="/" className="gray-bordered-button-sm">Learn more</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}